import { useTranslation } from '@mint-lib/i18n';
import { typographyVariants } from '@mint-lib/tw-components';

const NoFlights = () => {
  const { t } = useTranslation('@myn/planning_v2');

  return (
    <div className="flex h-full w-full flex-col items-center justify-center gap-2">
      <h4 className={typographyVariants({ variant: 'h4' })}>
        {t('No flights yet')}
      </h4>
      <p
        className={typographyVariants({
          variant: 'bodyShort01',
          color: 'secondary',
        })}
      >
        {t('Get started with your first flight creation.')}
      </p>
    </div>
  );
};

export default NoFlights;
